import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_white",
  "use": "icon-icon_arrow_white-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"icon-icon_arrow_white\"><path d=\"M.471.971c.26-.26.683-.26.943 0l5.657 5.657a.665.665 0 0 1 .195.48.665.665 0 0 1-.195.48l-5.657 5.656a.667.667 0 0 1-.943-.943l5.194-5.193L.471 1.914a.667.667 0 0 1 0-.943Z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol